import { render, staticRenderFns } from "./MoneyInputConfig.vue?vue&type=template&id=7c43d408&scoped=true"
import script from "./MoneyInputConfig.vue?vue&type=script&lang=js"
export * from "./MoneyInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43d408",
  null
  
)

export default component.exports